import { render, staticRenderFns } from "./ApiLookupsList.vue?vue&type=template&id=747d46e2&scoped=true&"
import script from "./ApiLookupsList.vue?vue&type=script&lang=js&"
export * from "./ApiLookupsList.vue?vue&type=script&lang=js&"
import style0 from "./ApiLookupsList.vue?vue&type=style&index=0&id=747d46e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747d46e2",
  null
  
)

export default component.exports